import 'scripts/bem'

// load the stylin
import '../_bundles/product.css'

// load the common blocks
import * as blocks from '../_bundles/product.js'

// load the run script
import Compiler from 'scripts/run.js'

Compiler.run(blocks)
